$(document).on('click', '.btn-popup-option-sign-up', function (e) {
    e.preventDefault();

    $(".sign-up-wrapper").removeClass("hide");

    $(".sign-in-wrapper").addClass("hide");
    $(".forgot-password-wrapper").addClass("hide");
    $(".apply-as-guest-wrapper").addClass("hide");
});

$(document).on('click', '.btn-popup-option-sign-in', function(e) {
    e.preventDefault();

    $(".sign-in-wrapper").removeClass("hide");
    
    $(".forgot-password-wrapper").addClass("hide");
    $(".sign-up-wrapper").addClass("hide");
    $(".apply-as-guest-wrapper").addClass("hide");
});

$(document).on('click', '.btn-popup-option-apply-as-guest', function(e) {
    e.preventDefault();

    $(".apply-as-guest-wrapper").removeClass("hide");

    $(".sign-up-wrapper").addClass("hide");
    $(".sign-in-wrapper").addClass("hide");
    $(".forgot-password-wrapper").addClass("hide");
});